import { RPIssueStatus } from '@/api/dashboard'
import { Badge } from '@/ui'
import { useTranslation } from 'react-i18next'

export const RPIssueStatusBadge = ({ status }: { status: RPIssueStatus }) => {
  const { t } = useTranslation()

  const variants = {
    [RPIssueStatus.Issued]: 'green-tertiary',
    [RPIssueStatus.Revoked]: 'violet-secondary',
    [RPIssueStatus.Skipped]: 'gray-tertiary',
    [RPIssueStatus.IssueFailed]: 'red-secondary',
    [RPIssueStatus.RevokeFailed]: 'red-secondary',
  }

  return <Badge variant={variants[status] as 'gray-primary'}>{t(`transaction-details.rp-status.${status}`)}</Badge>
}
